var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_link",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_586",
    "data-name": "\\u30D1\\u30B9 586",
    d: "M0,0H25V25H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_587",
    "data-name": "\\u30D1\\u30B9 587",
    d: "M17.75,7h-4.2V9h4.2a3.087,3.087,0,0,1,3.15,3,3.087,3.087,0,0,1-3.15,3h-4.2v2h4.2A5.131,5.131,0,0,0,23,12,5.131,5.131,0,0,0,17.75,7Zm-6.3,8H7.25A3.087,3.087,0,0,1,4.1,12,3.087,3.087,0,0,1,7.25,9h4.2V7H7.25A5.131,5.131,0,0,0,2,12a5.131,5.131,0,0,0,5.25,5h4.2ZM8.3,11h8.4v2H8.3Z",
    transform: "translate(0 1)",
    fill: "#72383D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon_link.435a6ed604e4163f54717239a7028ca8.svg";
export { ForwardRef as ReactComponent };